module.exports = __webpack_public_path__ + "img/call-icon.22753369.svg";